const SET_LOADING = '/loading/SET_LOADING';

export default {
    SET_LOADING,
};
